import { useNavigate } from "react-router-dom";
import { StationsList } from "../data/MenuData";
import toPLN from "../global/toPLN";
import useRole from "../../hooks/useRole";

export default function StationWidgets({ data }) {
    const role = useRole();
    const navigate = useNavigate();
    const getName = (code) => StationsList.find(s => s.code === code)?.name ?? code;

    const sorted = [...data].sort((a, b) => b.today.total.volume - a.today.total.volume);

    return (
        <div className="station-table-wrapper">
            <table className="station-table">
                <thead>
                    <tr>
                        <th className="station-table__rank">#</th>
                        <th className="station-table__name-col">Stacja</th>
                        <th className="station-table__num">Wolumen</th>
                        {role !== 'supply' && <th className="station-table__num">Marża netto</th>}
                        <th className="station-table__num">Klienci</th>
                    </tr>
                </thead>
                <tbody>
                    {sorted.map((item, i) => {
                        const t = item.today.total;
                        const isFirst = i === 0;
                        return (
                            <tr key={item.station} className={`station-table__row${isFirst ? ' station-table__row--first' : ''}`} onClick={() => navigate(`/station?station=${item.station}`)} style={{ cursor: 'pointer' }}>
                                <td className="station-table__rank">
                                    <span className={`station-table__medal${isFirst ? ' station-table__medal--first' : ''}`}>
                                        {i + 1}
                                    </span>
                                </td>
                                <td>
                                    <div className="station-table__name-col">
                                        <span className={`station-table__dot${isFirst ? ' station-table__dot--first' : ''}`} />
                                        <span className="station-table__station-name">{getName(item.station)}</span>
                                        <span className="station-table__code">{item.station}</span>
                                    </div>
                                </td>
                                <td className="station-table__num station-table__num--primary">
                                    {t.volume.toFixed(0)} l
                                </td>
                                {role !== 'supply' && <td className="station-table__num">{toPLN(t.margin)}</td>}
                                <td className="station-table__num">{t.clients}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
